import React from 'react';

import { TitleContainer } from './Title.styled';
import { Heading } from 'components/v2/Typography/Heading';

type Props = {
  text: string;
};

export const Title = ({ text }: Props) => (
  <TitleContainer>
    <Heading tag="h1" styledAs="h1" noMargin>
      {text}
    </Heading>
  </TitleContainer>
);
